import React from 'react';

export default function Logo() {
  return (
    <div className="flex gap-4 text-3xl font-bold text-primary">
      <img src="/logo.svg" width="32" height="32" alt="logo" />
      Task Chain
    </div>
  );
}
